export default __webpack_public_path__ + "static/media/regulatory--stop--g5.2a819d8f.png";